import OptionGroup from '../OptionGroup'
import StepShell, { Question, Hint } from '../StepShell'
import Field from '../Field'

const STAGES = [
  { label: 'Pre-seed', value: 'Pre-seed / bootstrapped' },
  { label: 'Seed', value: 'Seed' },
  { label: 'Series A', value: 'Series A' },
  { label: 'Series B+', value: 'Series B+' },
]
const TEAM_SIZES = ['1-5', '6-20', '21-50', '50+']

export default function StepDetailsStartup({ answers, dispatch, active }) {
  const onSelect = (group, value) => dispatch({ type: 'SET_ANSWER', field: group, value })
  return (
    <StepShell active={active} step={3} segment="startup">
      <Question>Where's the company at?</Question>
      <Hint>Helps us prioritize and right-size the hardware.</Hint>
      <Field label="Funding stage">
        <OptionGroup group="stage" options={STAGES} value={answers.stage} onSelect={onSelect} />
      </Field>
      <Field label="Engineers building with AI">
        <OptionGroup group="team" options={TEAM_SIZES} value={answers.team} onSelect={onSelect} />
      </Field>
    </StepShell>
  )
}
